const serviceData = [
  {
    title: "Data Centre Infrastructure",
    description:
      "We design and deliver complete data centre and server room environments with a focus on uptime, organized deployment, and future scalability.",
    image: "/images/drift_tech_data_center.svg",
    solutions: [
      "Rack and cabinet deployment",
      "Structured copper and fiber cabling",
      "PDU and patch panel setup",
      "Server and network hardware installation",
      "Room readiness and documentation",
      "Migration and expansion support",
    ],
  },
  {
    title: "Enterprise Wi-Fi & Networking",
    description:
      "We build reliable wired and wireless environments for offices, campuses, and commercial sites with secure, scalable network architecture.",
    image: "/images/wired_wireless_img.svg",
    solutions: [
      "Wi-Fi survey and access point planning",
      "Switching and routing deployment",
      "Controller and firewall configuration",
      "WAN and branch connectivity",
      "Network optimization and troubleshooting",
      "Secure enterprise segmentation",
    ],
  },
  {
    title: "Structured Cabling & Electronics Hardware",
    description:
      "We execute the physical layer that supports business operations, from site cabling to electronics hardware installation and integration.",
    image: "/images/facility_management_img.svg",
    solutions: [
      "CAT6 and fiber backbone deployment",
      "Patch panel dressing and labeling",
      "Field electronics mounting",
      "Power and connectivity coordination",
      "Testing and certification support",
      "Site handover documentation",
    ],
  },
  {
    title: "Surveillance & Access Control",
    description:
      "We integrate monitoring and access systems that improve site visibility, security, and operational control.",
    image: "/images/cyber_security_img.svg",
    solutions: [
      "CCTV camera deployment",
      "NVR and storage setup",
      "Access control device installation",
      "Monitoring station integration",
      "Networked security architecture",
      "Maintenance and support",
    ],
  },
  {
    title: "Power, Racks & Facility Support",
    description:
      "We support the infrastructure that keeps critical equipment organized, powered, and deployment-ready.",
    image: "/images/sd_wan_img.svg",
    solutions: [
      "Rack assembly and positioning",
      "Cable management systems",
      "Power distribution coordination",
      "UPS and equipment placement support",
      "Equipment relocation assistance",
      "Expansion and retrofit work",
    ],
  },
  {
    title: "Annual Maintenance & Support Services",
    description:
      "We provide ongoing support to keep integrated systems stable, documented, and operational throughout their lifecycle.",
    image: "/images/about_us_img.svg",
    solutions: [
      "Preventive maintenance visits",
      "Break-fix support and diagnostics",
      "Configuration backup and updates",
      "Health checks and reporting",
      "Spare coordination and replacements",
      "AMC and post-deployment support",
    ],
  },
];

export default serviceData;
